export const defaultDescription = `1- Termin Süresi : Sipariş onayını müteakip 2-3 Haftadır.                         
2- Siparişin toplam tutarı tahsil edilmeden ürün teslimatı yapılmaz.
3- Özel imalat ürünlerde iade kabul edilmez.
4- Teklifimiz, verildiği tarihten itibaren 10 gün geçerlidir.
5- Ampuller hediye olarak verilmektedir, iade ve değişim yapılmamaktadır.`;
